import { useRequest } from "../../../app/hooks/useRequest";
import { getCinsFinsElibilityCriteraRequest } from "../CinsFinsElibilityCriteriaRequests";

export const useGetCinsFinsEligibilityCriteria = () =>
  useRequest(getCinsFinsElibilityCriteraRequest);
